import { Instance, cast, types } from 'mobx-state-tree'
import { CopyrightAuthStatus, CopyrightUserType } from '~/graphqls/types'

const UserBase = types.model({
  uid: types.number,
  mobile: types.maybeNull(types.string),
})

const UserRoleInfo = types.model({
  aiArtist: types.maybeNull(types.boolean),
  artist: types.maybeNull(types.boolean),
})

const IntegralWallet = types
  .model({
    availableBalance: types.maybeNull(types.number),
    frozenBalance: types.maybeNull(types.number),
    memberCardIntegralBalance: types.maybeNull(types.number),
    totalAvailableBalance: types.maybeNull(types.number),
    originCardBalance: types.maybeNull(types.number),
  })
  .actions(self => {
    const setAvailableBalance = (value: number) => {
      self.availableBalance = Number(self.availableBalance) - value
    }
    return {
      setAvailableBalance,
    }
  })

export const UserStore = types
  .model({
    avatarUrl: types.maybeNull(types.string),
    nickname: types.maybeNull(types.string),
    /** 认证状态 */
    authStatus: types.maybeNull(types.string),
    backgroundUrl: types.maybeNull(types.string),
    blockChainAddress: types.maybeNull(types.string),
    userRoleInfo: types.maybeNull(UserRoleInfo),
    personalizedSignature: types.maybeNull(types.string),
    integralWalletBalance: types.maybeNull(IntegralWallet),
    areaCode: types.maybeNull(types.string),
    base: types.maybeNull(UserBase),
    inviteCode: types.maybeNull(types.string),
    /** 用户类型 */
    userType: types.maybeNull(
      types.enumeration(Object.values(CopyrightUserType))
    ),
    social: types.maybeNull(
      types.model({
        fansCount: types.number,
        likesCount: types.number,
        followCount: types.number,
      })
    ),
    muzzleStatus: types.maybeNull(types.boolean),
    muzzleEndTime: types.maybeNull(types.string),
    memberDetail: types.maybeNull(
      types.model({
        hold: types.maybeNull(types.boolean),
        endTime: types.maybeNull(types.number),
      })
    ),
    /** 是否是广场白名单用户 */
    isPlazaWhiteListUser: types.maybeNull(types.boolean),
    isAiWhiteListUser: types.maybeNull(types.boolean),
    /** 会员 */
    isVip: types.maybeNull(types.boolean),
    /** 白名单or会员 */
    isHighUser: types.maybeNull(types.boolean),
  })
  .actions(self => {
    const setBaseInfo = (base: IUserBase) => {
      self.base = base
    }
    const setIntegralWalletBalance = (
      integralWalletBalance: IIntegralWallet
    ) => {
      self.integralWalletBalance = integralWalletBalance
    }

    const setAvatarUrl = (url: string) => {
      self.avatarUrl = url
    }

    const setOrganizationAuthStatus = () => {
      self.userType = CopyrightUserType.COMPANY
      self.authStatus = CopyrightAuthStatus.AUTH
    }

    return {
      setBaseInfo,
      setIntegralWalletBalance,
      setAvatarUrl,
      setOrganizationAuthStatus,
    }
  })

export type IIntegralWallet = Instance<typeof IntegralWallet>
export type IUserBase = Instance<typeof UserBase>
export type IUserStore = Instance<typeof UserStore>
